










































import { Component, Mixins } from 'vue-property-decorator'
import { LibraryMixin } from '@/mixins'
import { ITutorialSlide } from '../../../../components/Tutorial.vue'

enum VIEWS {
  Main = 'main',
  Advanced = 'advanced'
}

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default,
    AutoExtractArtist: require('./AutoExtractArtist').default,
    ExtractRemixer: require('./ExtractRemixer').default,
    RemoveGarbage: require('./RemoveGarbage').default,
    ReplaceWithSpace: require('./ReplaceWithSpace').default,
    RemoveNumberPrefix: require('./RemoveNumberPrefix').default,
    RemoveUrl: require('./RemoveUrl').default,
    ReplaceEncoded: require('./ReplaceEncoded').default,
    AddMixParenthesis: require('./AddMixParenthesis').default,
    ToTitleCase: require('./ToTitleCase').default,

    RegexReplace: require('./Advanced/RegexReplace').default,

    Tutorial: require('@/components/Tutorial').default
  }
})
export default class SmartFixes extends Mixins(LibraryMixin) {
  view: VIEWS = VIEWS.Main

  tutorialSlides: ITutorialSlide[] = [
    {
      html: `Smart Fixes are tools created to solve common problems DJs face in their library. If your tracks have website URLs in them, ugly titles, numbers in front of titles or things like that then Smart Fixes are here to help.<br>All Smart Fixes are very powerful but designed to be simple to use.<br><br>In this tutorial, I'm going to show you a few Smart Fixes and you'll see how easy it is.`
    },
    {
      image: 'smartfixes1.png',
      html: `I have a bunch of tracks in my library that have numbers in front of them. I'm sure you've seen this before.<br><br>I've chosen the <strong>Remove Number Prefix</strong> Smart Fix and clicked scan. Rekordcloud shows me which tracks have numbers in front of them. All I have to do now is click Confirm and the track titles are clean again!`
    },
    {
      image: 'smartfixes2.png',
      html: `The second Smart Fix I'm showing you is the <strong>Add Mix Parenthesis</strong>. I'm sure your library is full of remixes with titles in different styles. This Smart Fix aims to clean that up and make it one style.<br><br>I've already let rekordcloud scan my library and all I have to do is click Confirm and it's done.`
    },
    {
      image: 'smartfixes3.png',
      html: `The last Smart Fix in this tutorial is <strong>Extract Remixer</strong>. With this Smart Fix, you can put those Remixer tags to good use. You probably aren't using them at all now since they're almost never filled when you buy tracks. But this Smart Fix can instantly fix that problem. It works the same way again, I've already scanned and all I have to do is confirm. Could not be easier!<br><br>That's the end of the tutorial.<br>Smart Fixes are quick and easy to use. You should try them all and you'll be amazed how much cleaner your library can be.`
    }
  ]
}
